import { HttpContextToken } from '@angular/common/http';

/**
 * HTTP context token to skip the global loader for specific requests.
 *
 * Usage:
 * ```typescript
 * this.http.get('/api/data', {
 *   context: new HttpContext().set(SKIP_LOADER, true)
 * });
 * ```
 */
export const SKIP_LOADER = new HttpContextToken<boolean>(() => false);
